import { GroupTaskGroupNameComponent } from './group-task-group-name.component';

export const GroupTaskGroupNameModule = angular
  .module('sfMobile.components.groupTaskGroupName', [
    'sfMobile.services.places-lists',
    'sfMobile.services.users',
  ])
  .component('sfGroupTaskGroupName', GroupTaskGroupNameComponent).name;
